import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import { IoChatbubbleEllipsesOutline } from 'react-icons/io5';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import './AirbnbHostDashboard.css';
import Overview from './components/Overview';
import Units from './components/Units';
import Bookings from './components/Bookings';
import Payments from './components/Payments';
import Notifications from '../shared/Notifications/Notifications';
import Analytics from './components/Analytics';
import Agents from './components/Agents';
// import ManageFinances from './components/ManageFinances';
import Profile from '../Profile/Profile';
import Messages from '../shared/Messages/Messages';
import PropertyRatings from '../shared/PropertyRatings/PropertyRatings';
import TenantScore from '../Landlord/components/TenantScore';



const AirbnbHostDashboard = () => {
  const [activeSection, setActiveSection] = useState('overview');
  const [navigationState, setNavigationState] = useState({});
  const navigate = useNavigate();

  useScrollToTop(activeSection);

  useEffect(() => {
    const storedSubscriptionState = localStorage.getItem('tenantscore_subscription_state');
    if (storedSubscriptionState === 'required') {
      navigate('/subscription-plans', { replace: true, state: { returnTo: '/airbnb-host' } });
    }
  }, [navigate]);

  const handleNavigate = (section, state = {}) => {
    setActiveSection(section);
    setNavigationState(state);
  };
  const sidebarItems = [
    { id: 'overview', label: 'Dashboard', icon: '🏠', section: 'MANAGEMENT' },
    { id: 'units', label: 'Manage Rentals', icon: '🏡', section: 'MANAGEMENT' },
    { id: 'bookings', label: 'Bookings', icon: '📅', section: 'MANAGEMENT' },
    { id: 'payments', label: 'Payments', icon: '💳', section: 'MANAGEMENT' },
    // { id: 'manage-finances', label: 'Manage Finances', icon: '💰', section: 'FINANCE' },
    { id: 'agents', label: 'Agents', icon: '👤', section: 'MANAGEMENT' },
    { id: 'analytics', label: 'Analytics', icon: '📊', section: 'TRUST & SECURITY' },
    { id: 'property-ratings', label: 'Property Ratings', icon: '⭐', section: 'TRUST & SECURITY' },
    { id: 'tenant-score', label: 'Tenant Score', icon: '📈', section: 'TRUST & SECURITY' },
    { id: 'messages', label: 'Messages', icon: <IoChatbubbleEllipsesOutline />, section: 'COMMUNICATION' },
    { id: 'profile', label: 'My Profile', icon: '👤', section: 'SYSTEM' },
  ];

  const renderContent = () => {
    switch (activeSection) {
      case 'overview':
        return <Overview onNavigate={setActiveSection} />;
      case 'units':
        return <Units />;
      case 'bookings':
        return <Bookings navigationState={navigationState} onNavigate={handleNavigate} />;
      case 'payments':
        return <Payments />;
      /* case 'manage-finances':
        return <ManageFinances />; */
      case 'analytics':
        return <Analytics />;
      case 'agents':
        return <Agents />;
      case 'property-ratings':
        return <PropertyRatings dashboardScope="BNB" />;
      case 'tenant-score':
        return <TenantScore variant="bnb" navigationState={navigationState} />;
      case 'profile':
        return <Profile />;
      case 'messages':
        return (
          <Messages
            userRole="Airbnb Host"
            threadId={navigationState?.threadId}
            threadData={navigationState?.threadData}
          />
        );
      case 'notifications':
        return <Notifications onNavigate={handleNavigate} userRole="Airbnb Host" />;
      default:
        return <Overview onNavigate={setActiveSection} />;
    }
  };

  return (
    <div className="dashboard">
      <Sidebar items={sidebarItems} activeItem={activeSection} onItemClick={handleNavigate} variant="landlord" />
      <div className="dashboard-content">
        <Header 
          userRole="Airbnb Host" 
          activeSection={activeSection}
          onNavClick={handleNavigate}
        />
        <main className="dashboard-main">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default AirbnbHostDashboard;
